import React , {useState , useEffect} from 'react'
import HeaderRoutes from "../../components/HeaderRoutes/HeaderRoutes";
import { Grid , Box , Paper, Typography , Button , TextField} from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import axios from 'axios';
import config from '../../config/config';
import Toast from '../../config/Toast';
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const AddUpdateVersion = () => {
    const theme = useTheme();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState('');
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [loading , setLoading] = useState(true);
    const [andriodVersion , setAndriodVersion] = useState('')
    const [iosVersion , setIosVersion] = useState('')
    const navigate = useNavigate();

    const handleCreate = async () => {
        const data = {
            android_version : andriodVersion,
            ios_version : iosVersion,
        };
    
        const path = `${config.authServiceUrl}addVersion`;
        const token = localStorage.getItem("tokenId");
    
        try {
        const response = await axios.post(path, data, {
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            },
        }); 
            setSnackbarOpen(true);
            setMessage(response?.data?.message);
            setType('success');
            setTimeout(() => {
                navigate('/firehouse/versions')
            }, 2000);
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    const handleCloseSnackbar = () => {
      setSnackbarOpen(false);
    };

  return (
    <>
        <HeaderRoutes />
        <Paper sx={{ margin: isMobile ? '16px' : '16px', padding: '20px 20px'}}>
            <Box>
                <Typography
                    style={{
                        fontFamily: 'Karla',
                        fontStyle: 'normal',
                        fontSize: '20px',
                        lineHeight: '150%',
                        color: '#000000',
                        fontWeight: 500,
                    }}
                >
                    <span style={{marginRight:'10px' , cursor:'pointer'}} onClick={() => navigate('/firehouse/versions')}> <ArrowBackIcon fontSize="small"/></span>
                Add Version
                </Typography>
            </Box>

            <Box className = 'mt-5 px-3'>
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <TextField
                            fullWidth
                            placeholder="Andriod Version"
                            label="Andriod Version"
                            type='number'
                            value={andriodVersion}
                            onChange={(e) => setAndriodVersion(e.target.value)}
                        />
                    </Grid>
                    <Grid xs={6} className='px-2'>
                        <TextField
                            fullWidth
                            placeholder="IOS Version"
                            label="IOS Version"
                            type='number'
                            value={iosVersion}
                            onChange={(e) => setIosVersion(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Box className='mt-4'>
                <Button
                    variant="contained"
                    color="primary"
                    disabled = {!andriodVersion || !iosVersion}
                    sx={{backgroundColor: '#BF1D2D', fontSize: '16px', fontWeight: '500', padding:'20px' ,  height: '38px' }}
                    onClick={handleCreate}
                >
                    Submit
                </Button>
            </Box>
        </Paper>

        <Toast
            snackbarOpen={snackbarOpen}
            handleCloseSnackbar={handleCloseSnackbar}
            message={message}
            type={type}
        />
    </>
  )
}

export const EditUpdateVersion = () => {
    const theme = useTheme();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState('');
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [andriodVersion , setAndriodVersion] = useState('')
    const [iosVersion , setIosVersion] = useState('')
    const [loading , setLoading] = useState(true);
    const [showData , setShowData] = useState([])
    const navigate = useNavigate();
    let selectedId = useParams();


    const handleUpdate = async () => {
        const data = {
            android_version : andriodVersion,
            ios_version : iosVersion,
        };
    
        const path = `${config.authServiceUrl}updateVersion/${selectedId?.id}`;
        const token = localStorage.getItem("tokenId");
    
        try {
        const response = await axios.post(path, data, {
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            },
        }); 
            setSnackbarOpen(true);
            setMessage(response?.data?.message);
            setType('success');
            setTimeout(() => {
                navigate('/firehouse/versions')
            }, 2000);
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    const fetchDataShow = async () => {
        const token = localStorage.getItem("tokenId");
        const path = `${config.authServiceUrl}showVersion/${selectedId?.id}`;
        try {
            const response = await axios.get(path, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            setShowData(response?.data?.data)
        } catch (error) {
            console.error(error.response?.data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{
        fetchDataShow()
    } , [])

    useEffect(() => {
        if (showData) {
            setAndriodVersion(showData.android_version || '');
            setIosVersion(showData.ios_version || '');
        }
    }, [showData]);

    const handleCloseSnackbar = () => {
      setSnackbarOpen(false);
    };


  return (
    <>
        <HeaderRoutes />
        <Paper sx={{ margin: isMobile ? '16px' : '16px', padding: '20px 20px'}}>
            <Box>
                <Typography
                    style={{
                        fontFamily: 'Karla',
                        fontStyle: 'normal',
                        fontSize: '20px',
                        lineHeight: '150%',
                        color: '#000000',
                        fontWeight: 500,
                    }}
                >
                    <span style={{marginRight:'10px' , cursor:'pointer'}} onClick={() => navigate('/firehouse/versions')}> <ArrowBackIcon fontSize="small"/></span>
                Edit Version
                </Typography>
            </Box>

            <Box className = 'mt-5 px-3'>
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <TextField
                            fullWidth
                            placeholder="Andriod Version"
                            label="Andriod Version"
                            type='number'
                            value={andriodVersion}
                            onChange={(e) => setAndriodVersion(e.target.value)}
                        />
                    </Grid>
                    <Grid xs={6} className='px-2'>
                        <TextField
                            fullWidth
                            placeholder="IOS Version"
                            label="IOS Version"
                            type='number'
                            value={iosVersion}
                            onChange={(e) => setIosVersion(e.target.value)}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Box className='mt-4'>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{backgroundColor: '#BF1D2D', fontSize: '16px', fontWeight: '500', padding:'20px' ,  height: '38px' }}
                    onClick={handleUpdate}
                >
                    Submit
                </Button>
            </Box>
        </Paper>

        <Toast
            snackbarOpen={snackbarOpen}
            handleCloseSnackbar={handleCloseSnackbar}
            message={message}
            type={type}
        />
    </>
  )
}

